export default "__VITE_ASSET__CE$17ubV__"